import { Model } from '@shared-features/models/model';
import { Expose, Type } from 'class-transformer';
import { BidStatus } from '../enums/bid-status.enum';
import { FleetClassification } from '@shared-features/enums/fleet-classification.enum';

export class Bid extends Model {
  @Expose()
  id: number;
  @Expose()
  bidPrice: string;
  @Expose()
  customerPrice: string;
  @Expose()
  status: BidStatus;
  @Expose()
  createdAt: string;
  @Expose()
  fleet: {
    id: number;
    name: string;
    shipmentCount: number;
    isVerified: boolean;
    classification: FleetClassification;
  };

  @Expose()
  driver: {
    id: number;
    owner: string;
    shipmentCount: number;
    isVerifiedByElm: boolean;
  }
}

export class BidsData extends Model {
  @Expose()
  totalBids: number;
  @Expose()
  lowestBid: number | null;
  @Expose()
  highestBid: number | null;
  @Expose()
  @Type(() => Bid)
  bids: Bid[];
}
